module.exports = __webpack_public_path__ + "static/media/integral_list_item_03.67972125.png";